import Image from 'next/image';

import { CTA } from 'react-scale/components';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const GetStarted = ({ overtitle = 'DEV KIT', title, subtitle, color = '#FFFFFF', cta, cover }) => {
  const datasetCoverRef = useRef(null);

  useEffect(() => {
    if (!datasetCoverRef.current) return;

    let tiltTween;

    const tiltElement = e => {
      const xPos = e.clientX / window.width - 0.5;
      const yPos = e.clientY / window.height - 0.5;

      tiltTween = gsap.to(datasetCoverRef.current, 0.6, {
        rotationY: 15 * xPos,
        rotationX: 15 * yPos,
        ease: 'Power1.easeOut',
        transformPerspective: 900,
        transformOrigin: 'center'
      });
    };

    document.addEventListener('mousemove', tiltElement);

    return () => {
      tiltTween.kill();
      document.removeEventListener('mousemove', tiltElement);
    };
  }, []);

  return (
    <div className="flex items-center md:space-x-10 lg:space-x-20 xl:space-x-[90px] space-x-0 mx-auto flex-col md:flex-row justify-center">
      <picture className="hidden md:flex max-w-[250px] xl:max-w-none" ref={datasetCoverRef}>
        <Image
          quality={100}
          layout="intrinsic"
          src={cover.src}
          width={325}
          height={433}
          alt={cover.alt}
        />
      </picture>
      <div className="flex flex-col items-center md:items-start flex-1 md:mb-0 max-w-max md:max-w-none mx-auto">
        <p
          style={{ color }}
          className="uppercase text-sm leading-4 self-start md:leading-6 md:text-base tracking-[4px] mb-8 md:mb-6"
        >
          {overtitle}
        </p>
        <h5 className="text-3.5xl font-aeonik self-start  leading-[44px] md:text-4xl md:leading-10 xl:text-5xl xl:leading-[48px] mb-8">
          {title}
        </h5>
        <ReactMarkdown
          rehypePlugins={[rehypeRaw]}
          className="text-lg leading-8 mb-12 md:mb-8 self-start"
        >
          {subtitle}
        </ReactMarkdown>
        <picture className="md:hidden mb-12 md:mb-10 flex">
          <Image
            quality={100}
            layout="intrinsic"
            src={cover.src}
            width={257}
            height={343}
            alt={cover.alt}
          />
        </picture>
        <CTA cta={cta} />
      </div>
    </div>
  );
};

export default GetStarted;
